import React from "react";
import { Button } from "@amzn/awsui-components-react";
import { Investigation, Stage } from "../../lusca-search-api/generated-src";
import {
  InvestigationApiError,
  useUnconfirmDocumentRedrive,
} from "../../hooks/useInvestigations";

interface BackToCbeCheckProps {
  stage: Stage;
  investigation: Investigation;
  onError: (message: string) => void;
}

/**
 * Small "Back to CBE check" link for a case whose CBEs were confirmed by mistake: the DLQ
 * redrive step goes back to Check CBEs (and the DLQ redrive locks again). Owner only; renders
 * nothing unless the CBEs are confirmed and no DLQ redrive has started.
 */
export function BackToCbeCheck({
  stage,
  investigation,
  onError,
}: BackToCbeCheckProps) {
  const unconfirm = useUnconfirmDocumentRedrive(stage);
  const { documentRedrive: doc } = investigation;
  if (
    investigation.status !== "READY_TO_REDRIVE" ||
    doc?.stage !== "CONFIRMED" ||
    !doc.attemptId
  )
    return null;
  return (
    <Button
      variant="inline-link"
      data-testid="back-to-cbe-check"
      loading={unconfirm.isLoading}
      onClick={() => {
        unconfirm
          .mutateAsync({
            investigationId: investigation.id,
            expectedVersion: investigation.version,
            attemptId: doc.attemptId as string,
          })
          .catch((err: InvestigationApiError) => onError(err.message));
      }}
    >
      Back to CBE check
    </Button>
  );
}
